(function ($, Cobalt, undefined) {
    Cobalt.Notifications = {
        initialize: function () {
            Cobalt.Notifications.bindNotificationsNavBar();
            Cobalt.Notifications.bindNotificationPreferencesForm();
            Cobalt.Notifications.bindSubscribeLabel();
            Cobalt.Notifications.bindCollapsedLinks();

            var notificationsView = $(".j-notifications-view");
            if (notificationsView.length > 0) {
                Cobalt.Notifications.markNotificationsAsRead(notificationsView, $(".t-netbar-notifications .t-netbar-label"));
            }
        },
        bindCollapsedLinks: function () {
            var collapsedLinks = $(".j-show-notifications");
            if (collapsedLinks.length > 0) {
                collapsedLinks.each(function (i, val) {
                    var link = $(val);
                    link.click(function (e) {
                        e.preventDefault();
                        var collapsedNotifications = $(this).parent().siblings(".j-notifications");
                        if (collapsedNotifications.is(":visible")) {
                            $(this).addClass("hidden");
                            collapsedNotifications.hide();
                        } else {
                            $(this).removeClass("hidden");
                            collapsedNotifications.show();
                        }
                    });
                });
            }
        },
        bindNotificationsNavBar: function () {
            var notificationsContainer = $("#notifications");
            $(".j-netbar-link").click(function (e) {
                e.preventDefault();
                if (($('body').hasClass('responsive-enabled') && $('body').width() <= 1023) || Cobalt.detectIsOnMobile()) {
                    window.location = "/my-notifications";
                } else {
                    var netbarLink = $(this);
                    var url = netbarLink.attr("data-ajax-url");
                    var notifications;

                    if (!notificationsContainer.is(":visible")) {
                        $.get(url, function (results) {
                            notifications = $(results);
                            if (notificationsContainer.length < 1) {
                                notificationsContainer = $("<div>").attr("id", "notifications").hide();
                                $("body").append(notificationsContainer);
                            }
                            notificationsContainer.html(results);

                            // Position it
                            var topPosition = netbarLink.offset().top + 30;
                            var leftPosition = netbarLink.offset().left - 272;
                            notificationsContainer.css("top", topPosition.toString() + "px");
                            notificationsContainer.css("left", leftPosition.toString() + "px");

                            $('.netbar .netbar-notifications').addClass('notifications-open');
                            notificationsContainer.show();
                            Cobalt.triggerHtmlInsert(notificationsContainer);

                            Cobalt.Notifications.markNotificationsAsRead(notifications, netbarLink);
                        });
                    } else {
                        $('.netbar .netbar-notifications').removeClass('notifications-open');
                        notificationsContainer.hide();
                    }
                }
            });

            $("body").click(function (e) {
                var target = $(e.target);
                if (target.parents("#notifications").length < 1 && notificationsContainer.is(":visible")) {
                    if (!target.is("#notifications")) {
                        $('.netbar .netbar-notifications').removeClass('notifications-open');
                        notificationsContainer.hide();
                    }
                }
            });
        },
        bindNotificationPreferencesForm: function () {
            var wantsDigestCheckbox = $("#field-wants-digest-email:checkbox");
            var deliveryOptions = $(".p-delivery-options");
            if (wantsDigestCheckbox.length > 0 && deliveryOptions.length > 0) {
                if (wantsDigestCheckbox.is(":checked")) {
                    deliveryOptions.show();
                }
                else {
                    deliveryOptions.hide();
                }

                wantsDigestCheckbox.click(function (e) { deliveryOptions.toggle(); });
            }

            var enableNotifications = $("#field-enable-notifications:checkbox");
            var notificationsCheckboxes = $(".notification-setting:checkbox");
            if (enableNotifications.length > 0) {
                if (notificationsCheckboxes.filter(":checked").length == notificationsCheckboxes.length) {
                    enableNotifications.attr("checked", "checked");
                }

                enableNotifications.click(function () {
                    var isChecked = $(this).is(":checked");

                    notificationsCheckboxes.each(function () {
                        if (isChecked) {
                            $(this).attr("checked", "checked");
                        } else {
                            $(this).removeAttr("checked");
                        }
                    });
                });

                notificationsCheckboxes.each(function () {
                    $(this).change(function () {
                        if (notificationsCheckboxes.filter(":checked").length == notificationsCheckboxes.length) {
                            enableNotifications.attr("checked", "checked");
                        }
                        else {
                            enableNotifications.removeAttr("checked");
                        }
                    });
                });
            }
        },
        bindSubscribeLabel: function () {
            //Change Subscribe label
            $("body").on("click", ".j-notification-sub", function () {
                var $that = $(this);
                var span = $that.find("span");
                var subscribeText = $that.attr("data-subscribe-text") || "Subscribe";
                var unsubscribeText = $that.attr("data-unsubscribe-text") || "Unsubscribe";

                if ($that.hasClass("favorited")) {
                    $that.removeClass("favorited");
                    $that.attr("title", subscribeText);
                } else {
                    $that.addClass("favorited");
                    $that.attr("title", unsubscribeText);
                }

                if (span) {
                    if (span.text().indexOf(subscribeText) == 0) {
                        span.html(unsubscribeText);
                    }
                    else {
                        span.html(subscribeText);
                    }
                }
            });

            $('a.j-lock-sub').on('click', function () {
                var $that = $(this);
                var span = $that.find("span");

                if (span) {
                    if (span.text() == "Lock Thread") {
                        span.html("Unlock Thread");
                    } else {
                        span.html("Lock Thread");
                    }
                }
                location.reload();
            });


            var $notSubscriptionButton = $("ul.user-actions li a.j-notification-not-sub");
            if ($notSubscriptionButton.length > 0) {
                $notSubscriptionButton.on("click", function (e) {
                    e.preventDefault();
                });
            }

            Cobalt.Comment.onCommentCreated(function (newComment, form, data) {

                if (!data.notificationTypes) {
                    return;
                }
                for (var i = 0; i < data.notificationTypes.length; i++) {
                    var notificationType = data.notificationTypes[i];
                    var buttons = $(".j-notification-sub[data-notification-type=" + notificationType + "]");
                    buttons.each(function (i, val) {
                        var span = $(val).find("span");
                        var unsubscribeText = $(val).attr("data-unsubscribe-text") || "Unsubscribe";
                        span.html(unsubscribeText);
                    });
                }
            });
        },
        markNotificationsAsRead: function (notifications, netbarLink) {
            var postUrl = notifications.attr("data-mark-as-read-url");           
            var requestVerificationToken = $.cookie("RequestVerificationToken");
            if (requestVerificationToken) {
                $.post(postUrl, { 'request-verification-token': requestVerificationToken }, function() { netbarLink.find(".option-count").remove(); });
            } else {
                $.ajax({
                    url: "/refresh-request-verification-token",
                    type: 'POST',
                    dataType: 'json',
                    success: function() {
                        $.post(postUrl, { 'request-verification-token': $.cookie("RequestVerificationToken") }, function () { netbarLink.find(".option-count").remove(); });
                    }
                });
            }
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Notifications.js